import { API_BASE_URL } from './api'

// Google OAuth 配置 - 优先使用环境变量
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || '773615015931-f0b0kdu06j3vc6p1s4qd1veprgg5nvac.apps.googleusercontent.com'

// 回调地址跟随当前站点（生产 www.p1ur.com / Vercel 预览 / localhost），
// 每个用到的地址都必须在 Google Console 的 Authorized redirect URIs 里注册。
// p1ur.com 裸域统一映射到 www（Google 那边只注册了 www）。
const getRedirectUri = () => {
  const origin = window.location.hostname === 'p1ur.com' ? 'https://www.p1ur.com' : window.location.origin
  return `${origin}/oauth/callback`
}

// Google登录 - 使用传统OAuth 2.0重定向
export const signInWithGoogle = async () => {
  try {
    if (GOOGLE_CLIENT_ID === 'your-google-client-id') {
      throw new Error('Google Client ID not configured. Please set VITE_GOOGLE_CLIENT_ID in Vercel environment variables.')
    }

    const redirectUri = getRedirectUri()
    const scope = 'openid email profile'
    const responseType = 'code'
    const state = newOAuthState()

    // 保存状态参数和本次用的 redirect_uri（回调时要原样传给后端换 token）
    localStorage.setItem('google_oauth_state', state)
    localStorage.setItem('google_oauth_redirect_uri', redirectUri)

    const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?` +
      `client_id=${GOOGLE_CLIENT_ID}&` +
      `redirect_uri=${encodeURIComponent(redirectUri)}&` +
      `scope=${encodeURIComponent(scope)}&` +
      `response_type=${responseType}&` +
      `state=${state}&` +
      `access_type=offline&` +
      `prompt=select_account`

    // 重定向到Google OAuth
    window.location.href = authUrl

    return {
      success: true,
      message: 'Redirecting to Google OAuth...'
    }
  } catch (error) {
    console.error('Google sign in error:', error)
    throw error
  }
}

// 处理OAuth回调
// state 要不可预测：Math.random() 不是加密随机，而且原来还只取了
// toString(36).substring(7) —— 大约 5 个字符，可猜。
const newOAuthState = () => {
  const bytes = new Uint8Array(16)
  crypto.getRandomValues(bytes)
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')
}

export const handleGoogleCallback = async (code, state) => {
  try {
    // state 是这个流程唯一的 CSRF 防线：它证明「发起这次登录的浏览器」和
    // 「正在完成这次登录的浏览器」是同一个。
    //
    // 原来这里只在两边都存在且不相等时打一句 warning 然后继续，等于没有防线：
    // savedState 为 null（本浏览器根本没发起过这次登录）时连 warning 都不打。
    // 攻击者可以自己走一遍 Google 授权拿到一个有效 code，再把
    // /oauth/callback?code=<他的code> 发给受害者——受害者的浏览器会拿到
    // 攻击者账号的 JWT，之后填的地址、下的单、看的订单全在攻击者账号里。
    // 后端也没有校验 state（只在解构那行出现过），所以只能在这里挡。
    const savedState = localStorage.getItem('google_oauth_state')
    localStorage.removeItem('google_oauth_state')

    if (!savedState || !state || state !== savedState) {
      throw new Error('Sign-in could not be verified. Please start again from the sign-in button.')
    }

    const redirectUri = localStorage.getItem('google_oauth_redirect_uri') || getRedirectUri()

    // 清理（state 在上面校验完就已经删掉了，是一次性的）
    localStorage.removeItem('google_oauth_redirect_uri')

    // 发送授权码到后端（带上 redirectUri，后端换 token 时必须用同一个）
    const response = await fetch(`${API_BASE_URL}/auth/google/callback`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ code, state, redirectUri })
    })

    const result = await response.json()

    if (!result.success) {
      throw new Error(result.message || 'Google authentication failed')
    }

    return result
  } catch (error) {
    console.error('Google callback error:', error)
    throw error
  }
}
